<template>
  <div class="pa-2">
    <p class="text-h3 font-weight-bold">{{ title }}</p>

    <v-row v-if="loading">
      <v-col>Loading...</v-col>
    </v-row>

    <v-row v-if="!loading && !data.length">
      <v-col>No data available</v-col>
    </v-row>

    <v-row
      v-for="(item, index) in data"
      :key="index"
      :class="{'row-border': rowsCount > 1 && index !== rowsCount - 1}"
    >
      <v-col cols="10">{{ item[columnKey] }}</v-col>
      <v-col cols="2">{{ item[columnValue] }}</v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    columnKey: {
      type: String,
      default: 'provider_name'
    },
    columnValue: {
      type: String,
      default: 'total'
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    rowsCount: function () {
      return this.data.length;
    },
  },
}
</script>

<style scoped>
.row-border {
  border-bottom: 1px solid var(--v-grey-base);
}
</style>
